/* Dew & Dark — scroll-reveal + sticky mobile buy bar.
   Progressive enhancement only: everything is fully visible without this file.
   Load with `defer` in theme.liquid, after dew-dark.css. */

/* Central merchant-link registry — the ONE place to update outbound product
   links across every article, instead of hand-editing dozens of HTML files
   every time a link changes.

   HOW IT WORKS: every outbound CTA in an article's Body HTML carries the
   SPECIFIC product URL (no tracking today) plus data-dd-merchant="slug". The
   loop below APPENDS this registry's tracking params to that URL at page load,
   so when a program is approved you add the tag in ONE place and every article
   picks it up on next load. It never replaces the href — see the ⚠️ note on
   DD_MERCHANT_PARAMS below for the regression that rule exists to prevent.
   An empty or unmapped slug is a no-op and keeps the authored href.

   ⚠️ THE ATTRIBUTE IS data-dd-merchant, NOT data-dd-affiliate. This file was
   ported from the sibling reptile site, which used the -affiliate name; Dew &
   Dark standardised on -merchant everywhere (articles, AFFILIATE-PATTERNS.md,
   and the rel/target injection in dew-dark-article.liquid all use it). The
   loop below queried the OLD name until 2026-08-04, which meant this entire
   registry silently matched zero links — every href kept its untagged
   fallback. That failure is invisible until the moment a program goes live
   and the commission does not arrive, so keep the two names in sync if either
   ever changes. */
var DD_MERCHANT_PARAMS = {
  /* Slug -> affiliate tracking query params to APPEND to the link's own href.
     Articles mark outbound links with data-dd-merchant="slug" AND already carry
     the specific product URL (e.g. agenaastro.com/zwo-am3n.html). We append a
     tag to that URL; we never replace it.

     ⚠️ WHY APPEND, NOT REPLACE (regression fixed 2026-08-04). This registry was
     ported from the sibling reptile site, where a slug meant "a destination"
     (zen-4x2x2 -> /products/4x2x2-...) and the loop overwrote href outright.
     Dew & Dark's slugs are MERCHANTS, not products, so overwriting sent every
     link to the retailer's homepage — a reader who clicked "check current price"
     for a specific mount landed on agenaastro.com and had to search for it.
     Six distinct product URLs in DD-006 alone collapsed to one. Keep these
     values as query fragments only; never put a bare origin here.

     Terms live-verified 2026-08-02 (see 01 Merchant Verification/). Agena is the
     default target for imaging gear (4-5%); Unistellar for smart-telescope
     content (7% / ~$3,500 cart); HPS routes to house-brand Apertura because its
     MAP-brand SKUs may pay 0%; B&H and Adorama are 2% fallbacks.

     ALL EMPTY ON PURPOSE: no program is approved yet, because every one of them
     requires a live site to apply. An empty value means "leave the href exactly
     as the article authored it", which is the correct and safe state today.
     Fill a value in — e.g. 'agena': 'aff=12345' — the day a program approves,
     and every article picks it up on next page load. */
  'agena':      '',
  'unistellar': '',
  'hps':        '',
  'bh':         '',
  'adorama':    '',
  'zwo':        '',

  /* Deliberately absent — verified 2026-08-02 as having NO publisher program:
     Astronomics, Woodland Hills/telescopes.net, Celestron, Sky-Watcher USA.
     Link those brands through a retailer above, never direct. */
};

(function () {
  document.documentElement.classList.add('js-enabled');

  var merchantLinks = document.querySelectorAll('[data-dd-merchant]');
  Array.prototype.forEach.call(merchantLinks, function (a) {
    var slug   = a.getAttribute('data-dd-merchant');
    var params = DD_MERCHANT_PARAMS[slug];

    /* No entry, or no approved program yet -> leave the authored href alone.
       This is the normal state today and must stay a no-op, not a rewrite. */
    if (!params) return;

    var href = a.getAttribute('href');
    if (!href) return;

    /* Never tag an internal link: rel="sponsored nofollow" is correct on a paid
       outbound link but tells Google not to follow us to our own pages. */
    if (href.charAt(0) === '/') {
      a.removeAttribute('rel');
      a.removeAttribute('target');
      return;
    }

    a.href = href + (href.indexOf('?') === -1 ? '?' : '&') + params;
  });

  if (!('IntersectionObserver' in window)) return;

  var revealTargets = document.querySelectorAll('.dd-reveal');
  if (revealTargets.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dd-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    revealTargets.forEach(function (el) { io.observe(el); });
  }

  /* Sticky mobile buy bar: show once the real buy box has scrolled out of view. */
  var buyBox = document.querySelector('[data-dd-buy-box]');
  var stickyBar = document.querySelector('.dd-sticky-bar');
  if (buyBox && stickyBar) {
    var buyBoxObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
        });
      },
      { threshold: 0 }
    );
    buyBoxObserver.observe(buyBox);
  }

  /* Auto-generated article table of contents.
     Scans .dd-content for <h2 id="..."> and builds the jump-link list into
     every <ul data-dd-autotoc> found on the page — there are two: the sticky
     desktop rail's list and the collapsible mobile/tablet list near the top
     of the article (see dew-dark-article.liquid + the .dd-mobile-toc CSS
     breakpoint). Article Body HTML never has to hand-write (and keep in
     sync) either one. No headings with ids = no TOC rendered anywhere,
     fails silently rather than showing an empty box. */
  var tocLists = document.querySelectorAll('[data-dd-autotoc]');
  if (tocLists.length) {
    var headings = document.querySelectorAll('.dd-content h2[id]');
    tocLists.forEach(function (tocList) {
      if (headings.length) {
        var frag = document.createDocumentFragment();
        headings.forEach(function (h) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          frag.appendChild(li);
        });
        tocList.appendChild(frag);
      } else {
        var card = tocList.closest('.dd-rail-card, .dd-mobile-toc');
        if (card) card.style.display = 'none';
      }
    });
  }
})();

/* Keep --header-height accurate after a device rotation.
   ----------------------------------------------------------------------
   Dawn writes --header-height in exactly one place: StickyHeader.setHeaderHeight(),
   called on connect and from a `matchMedia('(max-width: 990px)')` CHANGE listener.
   There is no resize or orientationchange listener anywhere in the theme. A phone
   rotating 390 <-> 844 never crosses 990, so that change event never fires and the
   value stays frozen at whatever the page loaded at.

   That matters here because this store's header height IS width-dependent: the logo
   is 280px wide (not Dawn's 100px default) inside a 1fr/2fr/1fr grid, so it renders
   clamped to ~149px in portrait and its full 280px in landscape. Measured on the real
   theme: .section-header is 71px at 390 wide and 101px at 844 wide — so after a
   rotation the variable is wrong by ~30px.

   Two things read it: Dawn's own `.shopify-section-header-hidden{top:calc(-1 *
   var(--header-height))}`, and the mobile drawer block in dew-dark.css, where it
   sets the in-flow placeholder height that stops the document from shrinking while the
   header is pinned. A stale value there means the page loses that many pixels of
   reading position when the drawer closes.

   Measure .header-wrapper, NOT .section-header: while the drawer is open the section
   carries an explicit height driven by this very variable, so measuring the section
   would just read its own stale value straight back in.

   Deliberately additive: it only ever writes the same property Dawn writes, using the
   same measurement, so it cannot disagree with the theme — it just keeps it current in
   the cases Dawn misses. */
(function () {
  var header = document.querySelector('.section-header .header-wrapper')
            || document.querySelector('.section-header');
  if (!header) return;

  var pending;
  function syncHeaderHeight() {
    pending = null;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  function schedule() {
    if (pending) return;
    pending = requestAnimationFrame(syncHeaderHeight);
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  /* the logo is an <img>; its height settles after load, and web fonts can nudge the
     header too — re-measure once both have landed rather than trusting first paint */
  window.addEventListener('load', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  schedule();
})();
